import {ButtonAttach, ButtonMain, ButtonPromptHistory} from '@/biz/ai'
import {Common, normalizeUseAiArgs} from '@/pages/MainPage/panes/Ai/Common.jsx'
import ButtonChooseTemplate from './ButtonChooseTemplate.jsx'
import ButtonImportModel from './ButtonImportModel.jsx'
import useAi from './useAi.jsx'

export default function AiChatGenerateUv({
    bizMap,
    defaultDraft,
    prjId,
    scene,
    simpleFlow,
    sVer,
    title,
    updateWfMap,
    ...props
}) {
    const ai = useAi(normalizeUseAiArgs({
        bizMap,
        defaultDraft,
        prjId,
        scene,
        sVer,
        title,
        wfMap: JSON.stringify(simpleFlow),
    }))

    const tools = [
        <>
            <ButtonChooseTemplate />
        </>,

        <>
            <ButtonPromptHistory />
            <ButtonAttach />
            <ButtonMain />
            <ButtonImportModel updateWfMap={updateWfMap} />,
        </>
    ]

    return (
        <Common
            ai={ai}
            tools={tools}
            {...props}
        />
    )
}
